var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestCloudExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 100H200V160H180V100ZM180 180H200V200H180V180ZM100 0C45 0 0 45 0 100C0 155 45 200 100 200C123 200 143 192 160 180V80H198C189 34 148 0 100 0ZM142 142L90 110V50H105V102L150 129L142 142Z",
    fill: "#F36C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestCloudExpired);
export default __webpack_public_path__ + "static/media/test-cloud-expired.256727b1767e44cfb7c115281fe4af99.svg";
export { ForwardRef as ReactComponent };